import { Button, Checkbox, FormControlLabel, Toolbar, Box } from "@mui/material";
import { UploadFile as UploadFileIcon, PlayArrow as PlayArrowIcon, Save as SaveIcon, Download as DownloadIcon } from "@mui/icons-material";

interface Props {
	logs: boolean;
	onToggleLogs: (checked: boolean) => void;
	onFileImport: (file: File) => void;
	onAnalyze: () => void;
	onDownloadModel: () => void;
	onExportResult: () => void;
	onSave: () => void;
}

export const ToolbarToolsAnalysis = ({ logs, onToggleLogs, onFileImport, onAnalyze, onDownloadModel, onExportResult, onSave }: Props) => {
	return (
		<Toolbar sx={{ px: 0, gap: 1 }}>
			<Box display="flex" flexGrow={1} alignItems="center" gap={1}>
				<Button variant="outlined" startIcon={<UploadFileIcon />} component="label">
					Importar
					<input
						type="file"
						hidden
						accept=".csv"
						onChange={(e) => {
							const file = e.target.files?.[0];
							if (file) {
								onFileImport(file);
								e.target.value = "";
							}
						}}
					/>
				</Button>

				<Button variant="outlined" color="info" startIcon={<PlayArrowIcon />} onClick={onAnalyze}>
					Verificar
				</Button>

				<Button variant="contained" color="success" startIcon={<SaveIcon />} onClick={onSave}>
					Salvar
				</Button>
			</Box>

			<Button variant="text" color="primary" startIcon={<DownloadIcon />} onClick={onDownloadModel}>
				Baixar Modelo
			</Button>

			<Button variant="text" color="secondary" startIcon={<DownloadIcon />} onClick={onExportResult}>
				Exportar Resultado
			</Button>

			<FormControlLabel
				control={<Checkbox checked={logs} onChange={(e) => onToggleLogs(e.target.checked)} color="primary" />}
				label="Logs de Validação"
			/>
		</Toolbar>
	);
};
